module.exports = __webpack_public_path__ + "static/shoe-layers-1-8c642f3dc9b05e687211d40933ddd8c1.png";